import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-root">
      <header className="legal-header">
        <button className="legal-back" onClick={() => navigate('/')}>← Επιστροφή</button>
        <div className="legal-logo">✂ SalonBook</div>
      </header>

      <div className="legal-content">
        <div className="legal-hero">
          <div className="legal-badge">Νομικά</div>
          <h1>Πολιτική Απορρήτου</h1>
          <p>Τελευταία ενημέρωση: Μάιος 2026</p>
        </div>

        <div className="legal-body">

          <section>
            <h2>1. Εισαγωγή</h2>
            <p>Η SalonBook («εμείς», «μας», «η εταιρεία») δεσμεύεται να προστατεύει την ιδιωτικότητά σας. Η παρούσα Πολιτική Απορρήτου εξηγεί πώς συλλέγουμε, χρησιμοποιούμε και προστατεύουμε τα προσωπικά σας δεδομένα κατά τη χρήση της πλατφόρμας μας.</p>
          </section>

          <section>
            <h2>2. Δεδομένα που συλλέγουμε</h2>
            <h3>2.1 Δεδομένα λογαριασμού</h3>
            <ul>
              <li>Όνομα και επώνυμο</li>
              <li>Διεύθυνση email</li>
              <li>Αριθμός τηλεφώνου</li>
              <li>Στοιχεία επιχείρησης (όνομα κομμωτηρίου, διεύθυνση)</li>
            </ul>
            <h3>2.2 Δεδομένα κρατήσεων</h3>
            <ul>
              <li>Ονόματα και τηλέφωνα πελατών</li>
              <li>Ιστορικό κρατήσεων και υπηρεσιών</li>
              <li>Σημειώσεις συνεδριών</li>
            </ul>
            <h3>2.3 Τεχνικά δεδομένα</h3>
            <ul>
              <li>Διεύθυνση IP</li>
              <li>Τύπος browser και συσκευής</li>
              <li>Logs χρήσης της πλατφόρμας</li>
            </ul>
          </section>

          <section>
            <h2>3. Πώς χρησιμοποιούμε τα δεδομένα σας</h2>
            <ul>
              <li>Παροχή και βελτίωση των υπηρεσιών μας</li>
              <li>Διαχείριση κρατήσεων και ραντεβού</li>
              <li>Αποστολή ειδοποιήσεων και υπενθυμίσεων</li>
              <li>Τεχνική υποστήριξη</li>
              <li>Συμμόρφωση με νομικές υποχρεώσεις</li>
            </ul>
          </section>

          <section>
            <h2>4. Νομική βάση επεξεργασίας</h2>
            <p>Επεξεργαζόμαστε τα δεδομένα σας βάσει:</p>
            <ul>
              <li><strong>Εκτέλεσης σύμβασης:</strong> για την παροχή των υπηρεσιών που έχετε συμφωνήσει</li>
              <li><strong>Νόμιμου συμφέροντος:</strong> για τη βελτίωση της πλατφόρμας</li>
              <li><strong>Συγκατάθεσης:</strong> για marketing επικοινωνίες (μπορείτε να αποσύρετε οποτεδήποτε)</li>
              <li><strong>Νομικής υποχρέωσης:</strong> όπου απαιτείται από το νόμο</li>
            </ul>
          </section>

          <section>
            <h2>5. Κοινοποίηση δεδομένων</h2>
            <p>Δεν πωλούμε τα δεδομένα σας σε τρίτους. Μπορεί να κοινοποιήσουμε δεδομένα με:</p>
            <ul>
              <li>Παρόχους υπηρεσιών cloud (hosting, βάσεις δεδομένων)</li>
              <li>Αρχές όταν απαιτείται από νόμο</li>
            </ul>
          </section>

          <section>
            <h2>6. Ασφάλεια δεδομένων</h2>
            <p>Εφαρμόζουμε κατάλληλα τεχνικά και οργανωτικά μέτρα για την προστασία των δεδομένων σας, συμπεριλαμβανομένων κρυπτογράφησης SSL/TLS, ελέγχου πρόσβασης και τακτικών αντιγράφων ασφαλείας.</p>
          </section>

          <section>
            <h2>7. Διατήρηση δεδομένων</h2>
            <p>Διατηρούμε τα δεδομένα σας για όσο χρόνο είναι απαραίτητο για την παροχή των υπηρεσιών ή όπως απαιτείται από νόμο. Μετά τη διαγραφή λογαριασμού, τα δεδομένα διαγράφονται εντός 30 ημερών.</p>
          </section>

          <section>
            <h2>8. Τα δικαιώματά σας (GDPR)</h2>
            <p>Σύμφωνα με τον GDPR, έχετε δικαίωμα:</p>
            <ul>
              <li><strong>Πρόσβασης:</strong> να λάβετε αντίγραφο των δεδομένων σας</li>
              <li><strong>Διόρθωσης:</strong> να διορθώσετε ανακριβή δεδομένα</li>
              <li><strong>Διαγραφής:</strong> να ζητήσετε τη διαγραφή των δεδομένων σας</li>
              <li><strong>Περιορισμού:</strong> να περιορίσετε την επεξεργασία</li>
              <li><strong>Φορητότητας:</strong> να λάβετε τα δεδομένα σε δομημένη μορφή</li>
              <li><strong>Εναντίωσης:</strong> να αντιταχθείτε στην επεξεργασία</li>
            </ul>
            <p>Για να ασκήσετε τα δικαιώματά σας, επικοινωνήστε μαζί μας στο <a href="mailto:privacy@salonbook.gr">privacy@salonbook.gr</a></p>
          </section>

          <section>
            <h2>9. Cookies</h2>
            <p>Χρησιμοποιούμε μόνο απαραίτητα cookies για τη λειτουργία της πλατφόρμας (authentication, session management). Δεν χρησιμοποιούμε cookies για διαφημιστικούς σκοπούς.</p>
          </section>

          <section>
            <h2>10. Επικοινωνία</h2>
            <p>Για οποιαδήποτε ερώτηση σχετικά με την επεξεργασία των δεδομένων σας:</p>
            <ul>
              <li>Email: <a href="mailto:privacy@salonbook.gr">privacy@salonbook.gr</a></li>
              <li>Ταχυδρομική διεύθυνση: SalonBook, Αθήνα, Ελλάδα</li>
            </ul>
            <p>Έχετε επίσης το δικαίωμα να υποβάλετε καταγγελία στην <a href="https://www.dpa.gr" target="_blank" rel="noopener noreferrer">Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (ΑΠΔΠΧ)</a>.</p>
          </section>

        </div>
      </div>

      <footer className="legal-footer">
        <span>© {new Date().getFullYear()} SalonBook. Όλα τα δικαιώματα διατηρούνται.</span>
        <div className="legal-footer-links">
          <a href="/privacy">Πολιτική Απορρήτου</a>
          <a href="/terms">Όροι Χρήσης</a>
          <a href="/gdpr">GDPR</a>
        </div>
      </footer>
    </div>
  );
}